export const refreshTimeout = (handle : any, callback : any, duration : number) => {
    if(handle != null) window.clearTimeout(handle);
    handle = window.setTimeout(callback, duration);
    return handle;
}